// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./utils/Colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/svg/left-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/svg/right-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  padding: 0px;
  margin: 0px;
}

body{
  font-family: "Montserrat", sans-serif !important;
}

p{
  font-family: "Montserrat", sans-serif !important;
  font-weight: 400;
}

.app h1 {
  color: var(--textHiddenColor);
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  margin-right: 100px;
  --bs-pagination-border-color: unset !important;
}

div#principle_info,
div#accountProfile_info,
div#example_info,
div#principle1_info {
  display: none;
}

div#principle_filter,
div#accountProfile_filter,
div#example_filter,
div#principle1_filter {
  display: none;
}

.principle_length,
div#accountProfile_length,
div#example_length {
  display: none;
}

table#principle,
div#accountProfile,
table#principle {
  text-align: center;
}

li#principle_previous a,
li#accountProfile_previous a,
li#example_previous a,
li#principle1_previous a {
  font-size: 0px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: top center;
  width: 20px;
  height: 20px;
  display: inline-block;
  box-shadow: none;
}

li#principle_next a,
li#accountProfile_next a,
li#example_next a,
li#principle1_next a {
  font-size: 0px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: top center;
  width: 20px;
  height: 20px;
  display: inline-block;
  box-shadow: none;
}

div.dataTables_wrapper div.dataTables_paginate {
  /* margin-right: 100px; */
  /* position: fixed; */
  right: 16%;
  bottom: 20px;
  background: #ffff;
  margin-left: 70%;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: var(--buttonColor);
  border-color: var(--buttonColor);
  border-radius: 8px;
  color: #000;
  /* margin: 0px 10px; */
  box-shadow: none;
  height: 33px;
  width: 33px;
  /* margin-top: 4px; */
}

.page-link {
  position: relative;
  display: block;
  color: #000 !important;
  text-decoration: none;
  background-color: #fff;
  border: none;
  cursor: pointer;
}

.disabled {
  cursor: not-allowed;
  pointer-events: none;
}

/* table.dataTable thead > tr > th.sorting:after,
table.dataTable thead > tr > th.sorting_asc:after,
table.dataTable thead > tr > th.sorting_desc:after {
  top: 50%;
  content: "▾";
  font-size: 24px;
}

table.dataTable thead > tr > th.sorting:before,
table.dataTable thead > tr > th.sorting_asc:before,
table.dataTable thead > tr > th.sorting_desc:before {
  bottom: 50%;
  content: "▴";
  font-size: 24px;
} */

table#principle svg {
  font-size: 23px;
  cursor: pointer;
  /* color: #383838; */
}

.table > tbody {
  border-left: 2px solid #ccc;
  border-right: 2px solid #ccc;
  border-top: 2px solid #ccc !important;
  vertical-align: inherit;
  white-space: nowrap;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: #fff !important;
}

td {
  border-left: 1px solid #ccc !important;
}

.table > :not(caption) > * > * {
  font-size: 18px;
}

div#principle_length {
  font-size: 0px;
  margin-left: 160px;
  /* margin-bottom: 30px; */
}

.account-table-wrapper div#principle_length {
  font-size: 0px;
  margin-left: 160px;
  margin-bottom: 10px;
  margin-top: -54px;
}

.wallet-transation-table-wrapper div#principle_length {
  font-size: 0px;
  margin-left: 160px;
  /* margin-bottom: 50px; */
  margin-top: -56px;
}

.wallet-info-page-wrapper div#principle_length,
div#principle1_length {
  font-size: 0px;
  margin-left: 160px;
  margin-bottom: 25px;
  margin-top: -55px;
}

.tranfer-history-dropdown-wrapper div#principle_length {
  display: none;
}

.admin-user-table-wrapper div#principle_length {
  display: none;
}

div#principle_length select,
div#principle1_length select {
  border: 2px solid var(--buttonColor);
  border-radius: 10px;
  outline: none;
  color: #383838;
  font-size: 18px;
  font-weight: 400;
  outline: none;
  padding-top: 7px;
  padding-bottom: 7px;
  cursor: pointer;
}

.show-entries-text {
  /* position: absolute; */
  font-size: 24px;
  color: #383838;
  margin-bottom: 20px;
}

div#example_wrapper {
  text-align: center;
}




/**** ToolTip css **********/
/* START TOOLTIP STYLES */
[tooltip] {
  position: relative; /* opinion 1 */
}

/* Applies to all tooltips */
[tooltip]::before,
[tooltip]::after {
  text-transform: none; /* opinion 2 */
  font-size: 0.9em; /* opinion 3 */
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  position: absolute;
  display: none;
  opacity: 0;
}
[tooltip]::before {
  content: "";
  /* border: 5px solid transparent;  */
  z-index: 1001; /* absurdity 1 */
}
[tooltip]::after {
  content: attr(tooltip); /* magic! */
  text-align: left;
  max-width: 200px;
  min-width: 200px;
  padding: 0px;
  border-radius: 0.3ch;
  background: #fff;
  z-index: 1000; /* absurdity 2 */
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid ccc;
  color: #5d5d5d;
  font-size: 14px;
  font-weight: 400;
  white-space: normal;
  line-height: normal;
  /* margin-left: -45px; */
}

.symplex-icon-wrap [tooltip]::after {
  min-width: 96px;
  max-width: 200px;
}




/*********** Bootstrap tooltip css *****/
.tooltip-inner {
  background: #fff !important;
  box-shadow: 0px 3px 6px #00000029;
  color: #5d5d5d !important;
  font-size: 14px;
  z-index: 99;
  opacity: 1;
}

.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before,
.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #fff !important;

}

.bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before,
.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #fff !important;
}

.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #fff !important;
}

div#tooltip-right .tooltip-inner {
  max-width: 300px;
  text-align: left;
}

.tooltip.show {
  opacity: 1;
}


/*********** Bootstrap tooltip css *****/
div#tooltip-up {
  z-index: 999999;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;EACd,mDAA8C;EAC9C,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;EACd,mDAA+C;EAC/C,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;;;AAKA,4BAA4B;AAC5B,yBAAyB;AACzB;EACE,kBAAkB,EAAE,cAAc;AACpC;;AAEA,4BAA4B;AAC5B;;EAEE,oBAAoB,EAAE,cAAc;EACpC,gBAAgB,EAAE,cAAc;EAChC,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa,EAAE,gBAAgB;AACjC;AACA;EACE,sBAAsB,EAAE,WAAW;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,aAAa,EAAE,gBAAgB;EAC/B,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;;;AAKA,wCAAwC;AACxC;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,iCAAiC;;AAEnC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;;AAGA,wCAAwC;AACxC;EACE,eAAe;AACjB","sourcesContent":["@import url(\"./utils/Colors.css\");\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n*{\n  padding: 0px;\n  margin: 0px;\n}\n\nbody{\n  font-family: \"Montserrat\", sans-serif !important;\n}\n\np{\n  font-family: \"Montserrat\", sans-serif !important;\n  font-weight: 400;\n}\n\n.app h1 {\n  color: var(--textHiddenColor);\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  margin-right: 100px;\n  --bs-pagination-border-color: unset !important;\n}\n\ndiv#principle_info,\ndiv#accountProfile_info,\ndiv#example_info,\ndiv#principle1_info {\n  display: none;\n}\n\ndiv#principle_filter,\ndiv#accountProfile_filter,\ndiv#example_filter,\ndiv#principle1_filter {\n  display: none;\n}\n\n.principle_length,\ndiv#accountProfile_length,\ndiv#example_length {\n  display: none;\n}\n\ntable#principle,\ndiv#accountProfile,\ntable#principle {\n  text-align: center;\n}\n\nli#principle_previous a,\nli#accountProfile_previous a,\nli#example_previous a,\nli#principle1_previous a {\n  font-size: 0px;\n  background: url(\"./assets/svg/left-arrow.svg\");\n  background-repeat: no-repeat;\n  background-position: top center;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  box-shadow: none;\n}\n\nli#principle_next a,\nli#accountProfile_next a,\nli#example_next a,\nli#principle1_next a {\n  font-size: 0px;\n  background: url(\"./assets/svg/right-arrow.svg\");\n  background-repeat: no-repeat;\n  background-position: top center;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  box-shadow: none;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate {\n  /* margin-right: 100px; */\n  /* position: fixed; */\n  right: 16%;\n  bottom: 20px;\n  background: #ffff;\n  margin-left: 70%;\n}\n\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: var(--buttonColor);\n  border-color: var(--buttonColor);\n  border-radius: 8px;\n  color: #000;\n  /* margin: 0px 10px; */\n  box-shadow: none;\n  height: 33px;\n  width: 33px;\n  /* margin-top: 4px; */\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: #000 !important;\n  text-decoration: none;\n  background-color: #fff;\n  border: none;\n  cursor: pointer;\n}\n\n.disabled {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* table.dataTable thead > tr > th.sorting:after,\ntable.dataTable thead > tr > th.sorting_asc:after,\ntable.dataTable thead > tr > th.sorting_desc:after {\n  top: 50%;\n  content: \"▾\";\n  font-size: 24px;\n}\n\ntable.dataTable thead > tr > th.sorting:before,\ntable.dataTable thead > tr > th.sorting_asc:before,\ntable.dataTable thead > tr > th.sorting_desc:before {\n  bottom: 50%;\n  content: \"▴\";\n  font-size: 24px;\n} */\n\ntable#principle svg {\n  font-size: 23px;\n  cursor: pointer;\n  /* color: #383838; */\n}\n\n.table > tbody {\n  border-left: 2px solid #ccc;\n  border-right: 2px solid #ccc;\n  border-top: 2px solid #ccc !important;\n  vertical-align: inherit;\n  white-space: nowrap;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: #fff !important;\n}\n\ntd {\n  border-left: 1px solid #ccc !important;\n}\n\n.table > :not(caption) > * > * {\n  font-size: 18px;\n}\n\ndiv#principle_length {\n  font-size: 0px;\n  margin-left: 160px;\n  /* margin-bottom: 30px; */\n}\n\n.account-table-wrapper div#principle_length {\n  font-size: 0px;\n  margin-left: 160px;\n  margin-bottom: 10px;\n  margin-top: -54px;\n}\n\n.wallet-transation-table-wrapper div#principle_length {\n  font-size: 0px;\n  margin-left: 160px;\n  /* margin-bottom: 50px; */\n  margin-top: -56px;\n}\n\n.wallet-info-page-wrapper div#principle_length,\ndiv#principle1_length {\n  font-size: 0px;\n  margin-left: 160px;\n  margin-bottom: 25px;\n  margin-top: -55px;\n}\n\n.tranfer-history-dropdown-wrapper div#principle_length {\n  display: none;\n}\n\n.admin-user-table-wrapper div#principle_length {\n  display: none;\n}\n\ndiv#principle_length select,\ndiv#principle1_length select {\n  border: 2px solid var(--buttonColor);\n  border-radius: 10px;\n  outline: none;\n  color: #383838;\n  font-size: 18px;\n  font-weight: 400;\n  outline: none;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  cursor: pointer;\n}\n\n.show-entries-text {\n  /* position: absolute; */\n  font-size: 24px;\n  color: #383838;\n  margin-bottom: 20px;\n}\n\ndiv#example_wrapper {\n  text-align: center;\n}\n\n\n\n\n/**** ToolTip css **********/\n/* START TOOLTIP STYLES */\n[tooltip] {\n  position: relative; /* opinion 1 */\n}\n\n/* Applies to all tooltips */\n[tooltip]::before,\n[tooltip]::after {\n  text-transform: none; /* opinion 2 */\n  font-size: 0.9em; /* opinion 3 */\n  line-height: 1;\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  display: none;\n  opacity: 0;\n}\n[tooltip]::before {\n  content: \"\";\n  /* border: 5px solid transparent;  */\n  z-index: 1001; /* absurdity 1 */\n}\n[tooltip]::after {\n  content: attr(tooltip); /* magic! */\n  text-align: left;\n  max-width: 200px;\n  min-width: 200px;\n  padding: 0px;\n  border-radius: 0.3ch;\n  background: #fff;\n  z-index: 1000; /* absurdity 2 */\n  box-shadow: 0px 3px 6px #00000029;\n  border: 1px solid ccc;\n  color: #5d5d5d;\n  font-size: 14px;\n  font-weight: 400;\n  white-space: normal;\n  line-height: normal;\n  /* margin-left: -45px; */\n}\n\n.symplex-icon-wrap [tooltip]::after {\n  min-width: 96px;\n  max-width: 200px;\n}\n\n\n\n\n/*********** Bootstrap tooltip css *****/\n.tooltip-inner {\n  background: #fff !important;\n  box-shadow: 0px 3px 6px #00000029;\n  color: #5d5d5d !important;\n  font-size: 14px;\n  z-index: 99;\n  opacity: 1;\n}\n\n.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\n.bs-tooltip-top .tooltip-arrow::before {\n  border-top-color: #fff !important;\n\n}\n\n.bs-tooltip-auto[data-popper-placement^=\"right\"] .tooltip-arrow::before,\n.bs-tooltip-end .tooltip-arrow::before {\n  border-right-color: #fff !important;\n}\n\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .bs-tooltip-bottom .tooltip-arrow::before {\n  border-bottom-color: #fff !important;\n}\n\ndiv#tooltip-right .tooltip-inner {\n  max-width: 300px;\n  text-align: left;\n}\n\n.tooltip.show {\n  opacity: 1;\n}\n\n\n/*********** Bootstrap tooltip css *****/\ndiv#tooltip-up {\n  z-index: 999999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
